<section class="home-page" aria-labelledby="home-title">
  <section class="home-hero">
    <div class="home-hero-content">
      <span class="home-emblem"><img src="assets/psa-mark.png" alt="Marca PSA y otros incentivos a la conservación" /></span>
      <h1 id="home-title">Bienvenido al sistema de<br>registro de PSA y otros incentivos a la conservación</h1>
      <p>Es la herramienta de reporte para entidades diseñadoras o implementadoras de proyectos de PSA y otros incentivos a la conservación en el Territorio Nacional.</p>
      <a routerLink="/inicio-sesion" class="home-enter">Ingresar</a>
    </div>
  </section>
  <section class="home-download" aria-labelledby="download-title">
    <div>
      <h2 id="download-title">Descarga de estructura Geodatabase /<br>Shape File para subir información cartográfica PSA y otros incentivos a la conservación</h2>
      <p>A continuación encontrará la plantilla base para realizar el cargue correcto de los Shape File del formulario de registro de proyectos.</p>
      <p>Recuerde que este documento solo es necesario si su proyecto se encuentra en una etapa de inversión.</p>
      <button type="button" class="btn-govco">Descargar shapes</button>
    </div>
    <img class="home-shape-reference" src="assets/shape-download-reference-clean.png" alt="Descarga de información geográfica PSA y otros incentivos a la conservación" />
  </section>
  <section class="home-sponsors" aria-labelledby="sponsors-title">
    <h2 id="sponsors-title">Cooperación para el fortalecimiento del<br>Sistema de Registro PSA–ICADP</h2>
    <p>Este prototipo hace parte de los servicios de consultoría contratados por Expertise France a Brander Ideas S.A.S., en el marco de un proyecto de cooperación entre la Agencia Francesa de Desarrollo (AFD) y Expertise France. Su propósito es apoyar el Sistema de Registro de proyectos PSA e incentivos para la conservación del ONVS, en beneficio del Ministerio de Ambiente y Desarrollo Sostenible de Colombia.</p>
    <div class="sponsor-partners" aria-label="Entidades vinculadas al proyecto">
      <div class="sponsor-partner">
        <img src="assets/expertise-france.png" alt="Expertise France, Groupe AFD" />
        <span>Entidad contratante</span>
      </div>
      <div class="sponsor-partner">
        <img src="assets/brand-minambiente.png" alt="Ministerio de Ambiente y Desarrollo Sostenible" />
        <span>Entidad beneficiaria</span>
      </div>
    </div>
  </section>
</section>
